<template>
	<div>
		<div class="row mt-3">
			<div class="col-lg-12">
				<label for="">Observaciones</label>
				<textarea class="form-control" v-model="VehiculoObservacion.Observaciones" cols="10" rows="4"></textarea>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name:"Observacion",
    props:["poBtnSave","pIdVehiculo"],
	data() {
        return {
            Modal:true,
            FormName:'Observacion',
            EmitSeccion:this.poBtnSave.EmitSeccion,
            VehiculoObservacion:{
                IdVehiculoObservacion:0,
                IdVehiculo:0,
                Observaciones:'',
            },
            errorvalidacion:[]
        }
    },
	methods: {
		Guardar(){
            let formData=new FormData();
            formData.set('IdVehiculoObservacion',this.VehiculoObservacion.IdVehiculoObservacion);
            formData.set('IdVehiculo',this.VehiculoObservacion.IdVehiculo);
            formData.set('Observaciones',this.VehiculoObservacion.Observaciones);
            this.poBtnSave.toast=0;
            this.poBtnSave.disableBtn=true;
            this.$http.post('vehiculoobservacion/post',formData).then((res)=>{
                this.poBtnSave.disableBtn=false; 
                this.poBtnSave.toast=1;
                $("#Observacion").modal("hide");
                this.bus.$emit('ListaPrincipal');
            }).catch((err)=>{
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
            });
        },
		Limpiar(){
            this.VehiculoObservacion={
                IdVehiculoObservacion:0,
                IdVehiculo:0,
                Observaciones:'',
            }
        },
		Recuperar(){
            this.$http.get('vehiculoobservacion/recovery',{
                params:{
                    IdVehiculoObservacion:this.VehiculoObservacion.IdVehiculoObservacion
                }
            }).then((res)=>{
                const objres=res.data.data.vehiculoobservacion;
                this.VehiculoObservacion.IdVehiculoObservacion=objres.IdVehiculoObservacion;
                this.VehiculoObservacion.IdVehiculo=objres.IdVehiculo;
                this.VehiculoObservacion.Observaciones=objres.Observaciones;
            })
        },
	},
	created() {
		this.bus.$off("NewModal_"+this.EmitSeccion);
        this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id,IdVehiculo)=>{
            this.poBtnSave.disableBtn=false;
            this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
            this.Limpiar();
            if (IdVehiculo!==undefined) {
                this.VehiculoObservacion.IdVehiculo=IdVehiculo;
            }
            if (Id > 0) {
				this.VehiculoObservacion.IdVehiculoObservacion = Id;
				this.Recuperar();
			}
        });
	},
	computed:{
        typeCalendar:function(){
            return 'single';
        }
    }
}
</script>

<style>

</style>
